import { ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS, ADITIONAL_SERVICES_PRICE_CAL_TYPES } from "../constants/commonConstants";

export const AditionalServiceCostCalculator = (service, orderCost, costPerPage, pages) => {
  const cost = 0;
  if(!service) return cost;

  const fn = ADITIONAL_SERVICES_PRICE_CAL_FUNCTIONS[service.label];

  if(!fn) return cost;

  switch (service.costType) {
    case ADITIONAL_SERVICES_PRICE_CAL_TYPES.PER_PAGE:
      return fn({pages});
    case ADITIONAL_SERVICES_PRICE_CAL_TYPES.PERCENTAGE_PER_PAGECOST:
      return fn({pagePrice: costPerPage, pages});
    case ADITIONAL_SERVICES_PRICE_CAL_TYPES.PERCENTAGE_PER_TOTALCOST:
      return fn({totalCost: orderCost});
    case ADITIONAL_SERVICES_PRICE_CAL_TYPES.FIXED:
      return fn();
    case ADITIONAL_SERVICES_PRICE_CAL_TYPES.FREE:
      return fn();
    case ADITIONAL_SERVICES_PRICE_CAL_TYPES.PAGE_PERCENTAGE_WITH_MULTIPLIER:
      return fn({pagePrice: costPerPage, perPageMultiplier: service.perPageMultiplier});
    default:
      return cost;
  };
};
